const AttachmentsBar = ({ attachments, removeAttachment }) => {
	if (attachments.length === 0) return null;

	return (
		<div className="attachments-bar">
			{attachments.map((a, idx) => (
				<div key={idx} className="attachment-chip">
					{a.isImage ? (
						<img src={a.url} alt={a.name} className="attachment-thumb" />
					) : (
						<div className="attachment-ext">{a.name.split('.').pop()?.toUpperCase()}</div>
					)}
					<span className="attachment-name" title={a.name}>
						{a.name}
					</span>
					<button className="remove-attachment" onClick={() => removeAttachment(idx)}>
						×
					</button>
				</div>
			))}
		</div>
	);
};

export default AttachmentsBar;